import classNames from 'classnames';
import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import CowcamoTextLink from '@/components/CowcamoTextLink';
import { EXTERNAL_SIGN_UP_PATH } from '@/constants/external-pages';
import { getSiteOrigin } from '@/utils/site-origin';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

/**
 * A link to the cowcamo-rails sign-up page. Registration is handled by cowcamo-rails, not
 * in-experience (the in-experience register flow is disabled), so the sign-in page points
 * newcomers at that page. Renders nothing when the site origin is unknown.
 *
 * Kept as a cowcamo-owned component (with the label hardcoded — cowcamo is Japanese-only) so the
 * link lives outside upstream files: it keeps this cowcamo-specific string out of the shared
 * phrases and shrinks the touch on upstream pages to a single line, avoiding merge churn on
 * upstream syncs.
 */
const CowcamoSignUpLink = ({ className }: Props) => {
  const { experienceSettings } = useContext(PageContext);
  const siteOrigin = getSiteOrigin(experienceSettings);

  if (!siteOrigin) {
    return null;
  }

  return (
    <div className={classNames(styles.signUp, className)}>
      <CowcamoTextLink href={new URL(EXTERNAL_SIGN_UP_PATH, siteOrigin).href}>
        新規会員登録
      </CowcamoTextLink>
    </div>
  );
};

export default CowcamoSignUpLink;
